var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}.b,.c{stroke:none;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61,53.5,38.6,31.1,50.5,19.2,3,3,19.2,50.4,31.1,38.6,53.5,61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M 53.5 58.17157363891602 L 58.17157363891602 53.5 L 37.18578720092773 32.51421356201172 C 36.40473937988281 31.73316192626953 36.40473937988281 30.46683692932129 37.18578720092773 29.68578720092773 L 46.81517791748047 20.05639839172363 L 6.209951400756836 6.207879066467285 L 20.05963325500488 46.73102569580078 L 29.69176292419434 37.17983627319336 C 30.08171272277832 36.79315948486328 30.59082221984863 36.59999847412109 31.09997749328613 36.59999847412109 C 31.61187171936035 36.59999847412109 32.12380981445312 36.79537963867188 32.51421356201172 37.18578720092773 L 53.5 58.17157363891602 M 53.5 61 L 31.10000038146973 38.59999847412109 L 19.20000076293945 50.40000152587891 L 3 3 L 50.5 19.20000076293945 L 38.59999847412109 31.10000038146973 L 61 53.5 L 53.5 61 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f481ab53a18d0c8be79247655d7672a6.svg";
export { ForwardRef as ReactComponent };